module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Location-arrow-a281abab5b2d598c2c3a51332d91a15d.svg";